<template>
    <div>
      <v-bottom-navigation
        fixed
        color="white"
        class="elevation-10"
        grow
      >
        <v-btn
          v-for="(row, index) in menu"
          :key="row.icon"
          :to="row.url"
          @click="activebtn = index"
          class="nav-btn"
        >
          <v-badge
            v-if="row.icon === 'mdi-math-log' && countnotification > 0"
            :content="countnotification"
            color="red"
            overlap
          >
            <v-icon :color="activebtn === index ? 'fourth' : 'grey'">{{ row.icon }}</v-icon>
          </v-badge>
          <v-avatar
          size="35"
          color="grey lighten-4"
          v-else-if="row.icon === 'mdi-account-circle'" 
        >
          <img :src="$functions.UsersAvatar()" :alt="$functions.UsersID()">
        </v-avatar>
          <v-icon v-else :color="activebtn === index ? 'fourth' : 'grey'">
            {{ row.icon }}
          </v-icon>
          
          <!-- <span :class="activebtn === index ? 'active-text' : 'inactive-text'">{{ row.text }}</span> -->
        </v-btn>
      </v-bottom-navigation>
    </div>
  </template>
  
  <script>
  export default {
    data: () => ({
      countnotification: 0,
      activebtn: 0,
      login: false,
      menu: [
        { icon: 'mdi-home-variant', text: 'Beranda', url: '/' },
        { icon: 'mdi-message-text', text: 'Chat AI', url: '/chat' },
        { icon: 'mdi-math-log', text: 'Aktivitas', url: '/activity' },
        { icon: 'mdi-account-circle', text: 'Akun', url: '/account' },
      ],
    }),
    created() {
      this.CheckLogin();
      this.Count();
    },
    methods: {
      CheckLogin() {
        let usersid = this.$functions.UsersID();
        this.login = usersid !== null;
      },
      Count() {
        this.countnotification = 0; // Simulasi jumlah notifikasi
      },
    },
  };
  </script>
  
  <style scoped>
  .v-bottom-navigation {
    border-top: 1px solid #e0e0e0;
  }
  
  .nav-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-transform: none;
    font-size: 12px;
  }
  
  .active-text {
    color: #1976d2; /* Warna aktif */
    font-weight: bold;
  }
  
  .inactive-text {
    color: grey;
  }
  </style>
  